import React from 'react';
import { Route } from 'react-router';

import RegistrationFrame from '.';

type RegistrationRouteProps = {
  exact: boolean;
  path: string;
  component: React.ComponentType<any>;
};

export default function RegistrationRoute({
  exact,
  path,
  component: WrappedComponent
}: RegistrationRouteProps) {
  return (
    <Route
      exact={exact}
      path={path}
      render={routeProps => (
        <RegistrationFrame {...routeProps}>
          <WrappedComponent {...routeProps} />
        </RegistrationFrame>
      )}
    />
  );
}
